import { render, staticRenderFns } from "./RichTextEditorMenuBarItem.vue?vue&type=template&id=14647220&scoped=true&"
import script from "./RichTextEditorMenuBarItem.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorMenuBarItem.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditorMenuBarItem.vue?vue&type=style&index=0&id=14647220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14647220",
  null
  
)

export default component.exports